const RECENT_ROOMS_KEY = 'brio_recent_rooms';
const MAX_RECENT_ROOMS = 3;

function cleanRoomId(value: string): string {
    return value.trim().replace(/\s+/g, '-');
}

export function toRoomId(value: string): string {
    return cleanRoomId(value);
}

export function encodeRoomId(roomId: string): string {
    return encodeURIComponent(roomId);
}

export function decodeRoomId(roomIdParam: string): string {
    try {
        return decodeURIComponent(roomIdParam);
    } catch {
        return roomIdParam;
    }
}

export function getRecentRooms(): string[] {
    try {
        const raw = localStorage.getItem(RECENT_ROOMS_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed
            .filter((item): item is string => typeof item === 'string')
            .map(cleanRoomId)
            .filter(Boolean)
            .slice(0, MAX_RECENT_ROOMS);
    } catch {
        return [];
    }
}

export function addRecentRoom(roomId: string): string[] {
    const cleaned = cleanRoomId(roomId);
    if (!cleaned) return getRecentRooms();

    const next = [cleaned, ...getRecentRooms().filter(entry => entry !== cleaned)].slice(0, MAX_RECENT_ROOMS);
    try {
        localStorage.setItem(RECENT_ROOMS_KEY, JSON.stringify(next));
    } catch {
        // ignore localStorage errors
    }
    return next;
}
